import React, { useState } from "react";
import { UserAutocomplete, User } from "./UserAutocomplete";
import { useLoginAsUserMutation } from "../api/crossAuth";

interface QuickActionsProps {
    onPayTokens: () => void;
    onPayMarathon: () => void;
    isPayingTokens: boolean;
    isPayingMarathon: boolean;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
    onPayTokens,
    onPayMarathon,
    isPayingTokens,
    isPayingMarathon,
}) => {
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [userSearchValue, setUserSearchValue] = useState("");
    const [loginAsUser, { isLoading: isLoggingIn }] = useLoginAsUserMutation();

    const handleUserSelect = (user: User) => {
        setSelectedUser(user);
    };

    const handleLoginAsUser = async () => {
        if (!selectedUser) {
            alert("Пожалуйста, выберите пользователя");
            return;
        }

        try {
            const result = await loginAsUser({
                user_id: selectedUser.id,
            }).unwrap();

            if (result.success) {
                // Переходим в кабинет клиента под выбранным пользователем в новом окне
                window.open(result.url, "_blank");
            } else {
                alert("Ошибка при входе под пользователем");
            }
        } catch (error) {
            console.error("Login as user error:", error);
            alert("Ошибка при входе под пользователем");
        }
    };

    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                Быстрые действия
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 content-center">
                {/* <div className="flex flex-wrap gap-4 items-center justify-center">
                    <button
                        onClick={onPayTokens}
                        disabled={isPayingTokens}
                        className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-md disabled:opacity-50"
                    >
                        {isPayingTokens
                            ? "Начисление..."
                            : "Токены победителям Благо"}
                    </button>

                    <button
                        onClick={onPayMarathon}
                        disabled={isPayingMarathon}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md disabled:opacity-50"
                    >
                        {isPayingMarathon
                            ? "Начисление..."
                            : "Начислить за марафон"}
                    </button>
                </div> */}
                <div className="space-y-2">
                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                        Войти как пользователь:
                    </div>
                    <div className="flex flex-wrap gap-2">
                        <UserAutocomplete
                            value={userSearchValue}
                            onChange={setUserSearchValue}
                            onUserSelect={handleUserSelect}
                            placeholder="Поиск пользователя..."
                            className="w-full"
                        />
                        <button
                            onClick={handleLoginAsUser}
                            disabled={!selectedUser || isLoggingIn}
                            className=" bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoggingIn ? "Вход..." : "Войти как"}
                            </button>
                    </div>
                    {selectedUser && (
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            Выбран: {selectedUser.name} {selectedUser.surname}{" "}
                            (#{selectedUser.id})
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
